import { useMemo } from "react";
import MapContainer from "./MapContainer";
import MapMarker from "./MapMarker";

const FleetViewMap = ({
  mapRef,
  fleetList,
  selectedFleet,
  trackingFleetId,
  trackingPosition,
  isInitialLoading,
  isTracking,
  onMapReady,
  onFleetSelect,
  onTrack,
  onStopTracking,
}) => {
  //for markers bounds
  // NOTE:
  // This recalculates every polling cycle (5s).
  // Acceptable for ~1000 vehicles.
  // If scaling to 10k+, consider incremental bounds update instead.
  const markersForBounds = useMemo(() => {
    const markers = [];

    for (const f of fleetList) {
      if (f.lat != null && f.lng != null) {
        markers.push({
          position: { lat: f.lat, lng: f.lng },
        });
      }
    }

    return markers;
  }, [fleetList]);

  return (
    <MapContainer
      ref={mapRef}
      onMapReady={onMapReady}
      markers={markersForBounds}
      isLoading={isInitialLoading}
      isTracking={isTracking}
      trackingPosition={trackingPosition}
      onStopTracking={onStopTracking}
      selectedFleet={selectedFleet}
    >
      {/* todo ujj 401 */}
      {fleetList.map((fleet) => (
        <MapMarker
          key={fleet.vehicleId}
          fleet={fleet}
          isSelected={selectedFleet?.vehicleId === fleet.vehicleId}
          isTracking={trackingFleetId === fleet.vehicleId}
          onTrack={onTrack}
          onClick={onFleetSelect}
        />
      ))}
    </MapContainer>
  );
};

export default FleetViewMap;
